export default "__VITE_ASSET__DFpkcROu__"